import { combineReducers } from 'redux';
import subVenueCache from './subVenueCache.reducer';

const reducers = combineReducers({
    subVenueCache,
});

export default reducers;
